import { formatDate } from '@btime/helpers'
import React from 'react'

import { findReplyByQuestionId, getOSByTemplateId, getReplyValue } from '../../_helpers/pdfHelpers'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { useParentServiceOrder } from '../../_load/ParentServiceOrderLoader'
import Image from '../../../../../components/presentation/Image'
import Separator from '../../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'

const ETCServiceOrdersTemplate = ({ templateId }) => {
  const parentServiceOrder = useParentServiceOrder()

  const dateTime = formatDate('DD/MM/YYYY', parentServiceOrder.endDate)
  const name = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 41))
  const document = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 10))

  const service = getOSByTemplateId(templateId)

  return (
    <>
      <View
        pageBreakAfter
        style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
      >
        <Table width="100%" color="#333333">
          <TableRow color="#333333">
            <TableCol color="#333333" style={{ padding: '10px' }}>
              <Grid justify="center">
                <Image src="/pdfs/bosi/etc-logo.jpg" />
              </Grid>
            </TableCol>
            <TableCol color="#333333">
              <Text bold color="red" align="center" size={16}>
                NR-01
              </Text>
              <Text bold align="center" size={16}>
                ORDEM DE SERVIÇO
              </Text>
              <Text bold align="center" size={16}>
                SEGURANÇA E SAÚDE DO TRABALHO
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#333333">
            <TableCol color="#333333" colSpan={2} style={{ padding: '10px' }}>
              <Text align="justify">
                Pela presente Ordem de Serviço objetivamos informar os trabalhadores que executam suas atividades
                laborais nesse setor, conforme estabelece a NR-1, item 1.7, sobre as condições de segurança e saúde, bem
                como aos riscos aos quais estão expostos, como medida preventiva e ,tendo como parâmetro os agentes
                físicos,químicos,e biológicos citados na NR-9 - Programa de Prevenção de Riscos Ambientais(Lei nº 6514
                de 22/12/1977,Portaria nº 3214 de 08/06/1978), bem como os procedimentos de aplicação da NR-6 -
                Equipamento de Proteção Individual – EPI, NR-17 – Ergonomia, de forma a padronizar comportamentos para
                prevenir acidentes e/ou doenças ocupacionais.
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#333333">
            <TableCol color="#333333" style={{ padding: '10px' }}>
              <Text>
                <strong>Nome:</strong> {name}
              </Text>
              <Text>
                <strong>CPF:</strong> {document}
              </Text>
            </TableCol>
            <TableCol color="#333333" style={{ padding: '10px' }}>
              <Text>
                <strong>Empresa:</strong> Bosi Terraplenagem Ltda
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#333333">
            <TableCol color="#333333" style={{ padding: '10px' }}>
              <Text>
                <strong>Setor:</strong> Produção
              </Text>
            </TableCol>
            <TableCol color="#333333" style={{ padding: '10px' }}>
              <Text>
                <strong>Função:</strong> {service.role}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#333333">
            <TableCol color="#333333" colSpan={2} style={{ padding: '10px' }}>
              <Text bold align="center">
                ATIVIDADES
              </Text>
              <Separator weight={4} />
              <Text bold color="red">
                Descrição das Atividades:
              </Text>
              <Text>{service.description}</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#333333">
            <TableCol color="#333333" colSpan={2} style={{ padding: '10px' }}>
              <Text bold align="center">
                RISCO E AVALIAÇÃO
              </Text>
              <Separator weight={4} />
              <Text>
                <strong>Físicos:</strong> {service.physicalRisks}
              </Text>
              <Text>
                <strong>Químicos:</strong> {service.chemicalRisks}
              </Text>
              <Text>
                <strong>Ergonômicos:</strong> {service.ergonomicRisks}
              </Text>
              <Text>
                <strong>De acidentes:</strong> {service.accidentsRisks}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#333333">
            <TableCol color="#333333" colSpan={2} style={{ padding: '10px' }}>
              <Text bold align="center">
                EQUIPAMENTOS DE PROTEÇÃO INDIVIDUAL (EPI) NECESSÁRIOS E/OU UTILIZADOS
              </Text>
              <Separator weight={4} />
              <Text>Botina de segurança com biqueira de aço</Text>
              <Text>Capacete com jugular</Text>
              <Text>Óculos de Proteção – Ampla Visão – Incolor</Text>
              <Text>Protetor Auricular – Inserção – Silicone ou concha (Abafador auditivo)</Text>
              <Text style={{ backgroundColor: 'yellow', width: 'fit-content' }}>
                (Para atividades em altura superior a 2 metros, Cinto de segurança tipo Paraquedista)
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#333333">
            <TableCol color="#333333" colSpan={2} style={{ padding: '10px' }}>
              <Text bold align="center">
                MEDIDAS PREVENTIVAS PARA OS RISCOS DE AMBIENTAIS
              </Text>
              <Separator weight={4} />
              <Text>➢ Uso correto de EPI`S;</Text>
              <Text>➢ Treinamento para execução das tarefas;</Text>
              <Text>➢ Atendimento às Normas de Segurança e Normas interna das empresas;</Text>
              <Text>➢ Treinamento das Normas Regulamentadora NR-06- NR-18 NR-33 NR-35.</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#333333">
            <TableCol color="#333333" colSpan={2} style={{ padding: '10px' }}>
              <Text bold align="center">
                ORIENTAÇÕES DE SEGURANÇA DO TRABALHO
              </Text>
              <Separator weight={4} />
              <Text>
                *Obedecer e respeitar as sinalizações e indicações de segurança contidas no local de trabalho;
              </Text>
              <Text>
                *Não transitar pelo local de trabalho sem o equipamento de proteção apropriado quando de fizer
                necessário;
              </Text>
              <Text>
                *Utilizar os Equipamentos de Proteção Individual apenas para a finalidade a que se destinam, mantendo-os
                sob sua guarda e conservação;
              </Text>
              <Text>
                *Observar atentamente o meio ambiente do trabalho, e solicitar as correções necessárias, junto às
                pessoas competentes, das condições inseguras encontradas, imediatamente;
              </Text>
              <Text>
                *Não ultrapassar seus limites físicos, ou seja, se não está habilitado para desempenhar qualquer
                atividade, não a faça.
              </Text>
              <Text>
                *Todo e qualquer acidente/incidente, o funcionário deve comunicar o fato de imediato ao setor de{' '}
                <strong>Segurança do Trabalho</strong> para que sejam tomadas as providências junto ao{' '}
                <strong>Médico do Trabalho</strong> da empresa.
              </Text>
            </TableCol>
          </TableRow>
        </Table>
      </View>

      <View
        pageBreakAfter
        style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
      >
        <Table color="#333333">
          <TableRow color="#333333">
            <TableCol color="#333333" colSpan={2} style={{ padding: '10px' }}>
              <Text>*Forneça ferramentas manuais e elétricas em boas condições de uso;</Text>
              <Text>*Não conserte nenhum equipamento energizado. Chame o eletricista;</Text>
              <Text>*Armazene separadamente materiais tóxicos, inflamáveis ou corrosivos;</Text>
              <Text>*Mantenha o almoxarifado organizado, limpo, bem iluminado e ventilado;</Text>
              <Text>*Mantenha em condições de uso os extintores de incêndio do almoxarifado;</Text>
              <Text>*Não fume, nem permita que fumem no recinto do almoxarifado;</Text>
            </TableCol>
          </TableRow>
          <TableRow color="#333333">
            <TableCol color="#333333" colSpan={2} style={{ padding: '10px' }}>
              <Text>
                Recebi treinamento de segurança e saúde no trabalho, bem com todos os equipamentos de proteção
                individual para neutralizar a ação dos agentes nocivos presentes no meu ambiente de trabalho.
              </Text>
              <Separator weight={6} />
              <Text>
                Estou ciente que serei cobrado, conforme ampara legal, com relação ao uso destes equipamentos e estou
                ciente de que a não utilização é passível de sansões legais.
              </Text>
              <Separator weight={10} />
              <Text align="center">Sete Lagoas - (MG) {dateTime}</Text>

              <Separator weight={8} />

              <Grid justify="center">
                <Col>
                  <div style={{ marginBottom: '-25px' }}>
                    <Image src="/pdfs/bosi/assinatura-tst.png" />
                  </div>
                  <Text align="center">__________________________________________</Text>
                  <Text align="center">Luciano Ribeiro da Silva</Text>
                  <Text align="center">Técnico em Segurança do Trabalho</Text>
                  <Text align="center">Reg. MTE: 21/0125</Text>
                </Col>
              </Grid>

              <Separator weight={16} />

              <Grid align="flex-end">
                <Col width="50%" gutter={8}>
                  <Text align="center">___________________________________________________</Text>
                  <Text align="center">ASSINATURA DO EMPREGADO</Text>
                  <Text align="center">{name}</Text>
                  <Text align="center">CPF: {document}</Text>
                </Col>
                <Col width="50%" gutter={8}>
                  <Text align="center">___________________________________________________</Text>
                  <Text align="center">ASSINATURA DO EMPREGADOR</Text>
                  <Text align="center">Bosi Terraplanagem Ltda</Text>
                  <Text align="center">CNPJ: 42.855.431/0001-80</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
        </Table>
      </View>
    </>
  )
}

export default ETCServiceOrdersTemplate
